import React from 'react';
import { BookOpenIcon, GiftIcon } from 'lucide-react';
import { Section } from './Shared';
import { FretDivider, KanjiBackdrop, Seal } from './Ornaments';
import { bonuses, bonusesTotalValue, tomes } from '../data/bonuses';
const atlasCoverUrl = 'https://cdn.magicpatterns.com/uploads/nrdXXmUDMkNvVUETEWbSe7/pasted-image.png';
const stats = [{
  value: '3',
  label: 'tomos'
}, {
  value: '118',
  label: 'páginas'
}, {
  value: '26',
  label: 'protocolos'
}, {
  value: '50+',
  label: 'puntos'
}];
export function PackContents() {
  return <Section id="contenido" className="relative" data-id="element-162" data-mp="isdr9e3jp5pv">
      <KanjiBackdrop glyphs={['經', '絡', '穴', '脈', '藥']} data-id="element-163" data-mp="44kes29rajbi" />
      <div className="mx-auto max-w-5xl text-center" data-id="element-164" data-mp="43r6uxz29nrs">
        <span className="inline-flex items-center gap-1.5 rounded-sm border border-brand-gold/60 bg-brand-paper px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-brand-forest shadow-sm" data-id="element-165" data-mp="92c4cpmxhtcj">
          <BookOpenIcon className="h-3.5 w-3.5 text-brand-goldDark" aria-hidden="true" data-id="element-166" data-mp="11jom26ce62n1" />
          Mira el atlas por dentro
        </span>
        <h2 className="mt-3 font-display text-[28px] font-bold leading-[1.02] text-brand-ink sm:text-4xl md:text-5xl" data-id="element-167" data-mp="3k8jp62wd7abv">
          Sin teoría interminable, sin libros de 500 páginas que nunca se usan
          en consulta:{' '}
          <span className="relative z-0 inline-block px-1.5 text-brand-cinnabar before:absolute before:inset-x-0 before:bottom-[0.06em] before:-z-10 before:h-[0.4em] before:-rotate-1 before:rounded-sm before:bg-brand-goldLight/90" data-id="element-168" data-mp="3u5g16ilh2el6">
            el punto exacto
          </span>
          , la imagen exacta, la técnica exacta.
        </h2>

        <div className="mx-auto mt-8 max-w-[260px] overflow-hidden rounded-md border border-brand-gold/50 shadow-[0_14px_40px_rgba(44,38,32,0.15)] sm:max-w-[320px] md:mt-10" data-id="element-169" data-mp="lol8fvye2akt">
          <video autoPlay loop muted playsInline className="w-full object-cover" data-id="element-170" data-mp="2nityt9v0peof">
            <source src="https://cdn.magicpatterns.com/uploads/3koTaKq1vxJNJH8Q2SnsGZ/Scroll_Acupuntura_magic.mp4" type="video/mp4" data-id="element-171" data-mp="387cz5sdrp4qr" />
            Tu navegador no soporta la reproducción de videos.
          </video>
        </div>
      </div>

      <div className="paper-card mx-auto mt-8 max-w-5xl rounded-sm border border-brand-gold/45 p-5 shadow-[0_14px_40px_rgba(44,38,32,0.09)] md:p-8" data-id="element-172" data-mp="3ha4fo6li2qp9">
        <div className="flex flex-col items-center gap-5 text-center sm:flex-row sm:items-center sm:gap-8 sm:text-left" data-id="element-173" data-mp="3r4wd9af31dk1">
          <img src={atlasCoverUrl} alt="Portada del Atlas Ancestral de Acupuntura rodeada por el material complementario" className="w-44 shrink-0 rounded-sm border border-brand-gold/50 bg-brand-surfaceLight/40 object-contain shadow-[0_12px_28px_rgba(44,38,32,0.2)] sm:w-52 md:w-64" loading="lazy" decoding="async" data-id="element-174" data-mp="3v5zsbupb35k7" />
          <div className="min-w-0" data-id="element-175" data-mp="iqxj8ebo8296">
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-brand-cinnabar" data-id="element-176" data-mp="inrr0q7qwk98">
              El pack principal
            </span>
            <h3 className="mt-1.5 font-serif text-2xl font-bold leading-tight text-brand-ink md:text-[2rem]" data-id="element-177" data-mp="1y8247tkqlcty">
              ATLAS ANCESTRAL DE ACUPUNTURA™
            </h3>
            <p className="mt-3 max-w-xl font-display text-lg leading-snug text-brand-text md:text-xl" data-id="element-178" data-mp="1ob5uxln0kmoc">
              Tu sistema visual completo para localizar el punto correcto,
              aplicarlo con técnica precisa y respaldarte con criterio clínico
              en cada sesión.
            </p>
            <p className="mt-3 text-xs font-semibold uppercase tracking-[0.12em] text-brand-goldDark" data-id="element-179" data-mp="2c8cxf39ir3ia">
              3 tomos · 118 páginas · 26 protocolos clínicos
            </p>
          </div>
        </div>

        <div className="mt-5 grid grid-cols-4 divide-x divide-brand-gold/35 rounded-sm border border-brand-gold/40 bg-brand-surfaceLight/45 px-2 py-3 text-center" data-id="element-180" data-mp="34pfjogv64dfp">
          {stats.map(stat => <div key={stat.label} className="px-1" data-id="element-181" data-mp="2kg690hdks8jb">
              <strong className="block font-serif text-lg leading-none text-brand-forest" data-id="element-182" data-mp="2kiipsr7lkcus">
                {stat.value}
              </strong>
              <span className="mt-1 block text-[9px] font-bold uppercase tracking-[0.1em] text-brand-muted" data-id="element-183" data-mp="2aj1kwc0662zv">
                {stat.label}
              </span>
            </div>)}
        </div>

        <ul className="mt-6 grid gap-5 md:grid-cols-3 md:gap-6" data-id="element-184" data-mp="336nm5dlxcvjk">
          {tomes.map(tome => <li key={tome.label} className="flex gap-3 md:flex-col md:gap-3" data-id="element-185" data-mp="386a2hvx1urwl">
              <div className="relative mt-0.5 w-14 shrink-0 md:mx-auto md:mt-0 md:w-24" data-id="element-186" data-mp="2thdt9vj9b8ue">
                <img src={tome.cover} alt={`Portada del ${tome.label}: ${tome.title}`} loading="lazy" decoding="async" className="aspect-[3/4] w-full rounded-sm border border-brand-ink/25 bg-brand-ink object-cover shadow-[0_6px_14px_rgba(44,38,32,0.22)]" data-id="element-187" data-mp="2yg79hvpxhdy9" />
                <span className="absolute -right-1.5 -top-1.5 flex h-5 w-5 items-center justify-center rounded-sm border border-brand-gold/60 bg-brand-paper font-kanji text-[10px] text-brand-goldDark" aria-hidden="true" data-id="element-188" data-mp="1ffoi7kdxyva0">
                  {tome.numeral}
                </span>
              </div>
              <div className="min-w-0 md:text-center" data-id="element-189" data-mp="wi5627w6swjd">
                <p className="font-serif text-sm font-bold text-brand-ink" data-id="element-190" data-mp="wix2fkxlyyap">
                  <span className="uppercase tracking-[0.08em] text-brand-cinnabar" data-id="element-191" data-mp="rkvikxscyuy6">
                    {tome.label}
                  </span>{' '}
                  — {tome.title}
                </p>
                <p className="mt-1 text-xs leading-relaxed text-brand-muted" data-id="element-192" data-mp="11gyngbelh7ot">
                  {tome.description}
                </p>
              </div>
            </li>)}
        </ul>

        <p className="mt-6 border-t border-brand-gold/30 pt-4 text-sm leading-relaxed text-brand-muted md:text-center" data-id="element-193" data-mp="2cw52h8vtq41v">
          Localización exacta del punto, meridiano de pertenencia, órgano
          asociado, técnica de inserción y acción terapéutica en una consulta
          rápida.
        </p>
      </div>

      <FretDivider character="贈" className="mt-14" data-id="element-194" data-mp="1jkoujkhsi3yx" />
      <div className="mt-6 text-center" data-id="element-195" data-mp="1nmaf7s0kfmjo">
        <h3 className="flex flex-wrap items-center justify-center gap-2 font-serif text-2xl font-bold text-brand-ink" data-id="element-196" data-mp="1nl8sure3ndmn">
          <GiftIcon className="h-5 w-5 text-brand-goldDark" aria-hidden="true" data-id="element-197" data-mp="qtezdimogmzz" />
          6 BONOS ESTRATÉGICOS —
          <span className="text-brand-forest" data-id="element-198" data-mp="zw7q9kry6wpa">GRATIS</span>
        </h3>
      </div>
      <div className="mx-auto mt-7 grid max-w-6xl grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-199" data-mp="zu3bu8wfafar">
        {bonuses.map(bonus => <article key={bonus.n} className="min-w-0" data-id="element-200" data-mp="85jr2e9u41e9">
            <div className="aspect-[3/4] overflow-hidden rounded-sm border border-brand-ink/25 bg-brand-ink shadow-[0_10px_24px_rgba(44,38,32,0.22)]" data-id="element-201" data-mp="84rvv4k5g5oi">
              <img src={bonus.cover} alt={`Portada del bono ${bonus.n}: ${bonus.title}`} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-202" data-mp="4ncih6aw8mta" />
            </div>
            <p className="mt-2 text-center text-[10px] font-bold uppercase tracking-wide text-brand-cinnabar" data-id="element-203" data-mp="3msphgpp0zq4o">
              Bono {bonus.n} — {bonus.title}
            </p>
            <p className="mt-1 min-h-[3.75rem] text-center text-[10px] leading-tight text-brand-muted" data-id="element-204" data-mp="3huxgz7abevov">
              {bonus.subtitle}
            </p>
            <p className="mt-2 text-center text-[10px] text-brand-muted" data-id="element-205" data-mp="383b4z8q5ksl2">
              <span className="line-through" data-id="element-206" data-mp="3427uz2usdqrr">{bonus.price}</span>{' '}
              <strong className="text-brand-forest" data-id="element-207" data-mp="3442eqdubncu9">→ GRATIS</strong>
            </p>
          </article>)}
      </div>
      <div className="mt-8 flex justify-center" data-id="element-208" data-mp="2u41sok52iimd">
        <span className="inline-flex items-center gap-3 rounded-sm border border-brand-gold/55 bg-brand-paper px-5 py-3 text-sm font-medium text-brand-text" data-id="element-209" data-mp="2u5cwgjyijqdh">
          <Seal characters="贈禮" className="h-9 w-9 text-[11px]" data-id="element-210" data-mp="qu6lattrdq6q" />
          <span data-id="element-211" data-mp="qtnb5zaco639">
            Valor total de los bonos{' '}
            <span className="text-brand-muted line-through" data-id="element-212" data-mp="ctm0xt873mb4">
              {bonusesTotalValue}
            </span>{' '}
            <strong className="text-brand-forest" data-id="element-213" data-mp="hs72bvz6oc15">
              → GRATIS con tu Atlas Ancestral
            </strong>
          </span>
        </span>
      </div>
    </Section>;
}